import { BaseService } from "services/base.service";
import { IUserStatus } from "models/InternalUser/UserStatusModel";
import { IInternalUserGridDetail } from "models/InternalUser/InternalUserGridDetailModel";
import { TableFilterModel } from "models/TableFilterModel";
import InternalUserDetailModel from "models/InternalUser/internalUserDetailModel";
import { IAddUpdateUserMenuAccessRight } from "models/InternalUser/UserModel";
import { IMenuAccessRightModel } from "models/MenuAccessRightModel";

class InternalUserServiceInternal extends BaseService {
	getInternalUserList = async (
		model: TableFilterModel
	): Promise<IInternalUserGridDetail[]> =>
		this.callApi<IInternalUserGridDetail[]>(
			`User/GetInternalUserList`,
			"POST",
			undefined,
			model
		);

	getUserStatusList = async (): Promise<IUserStatus[]> =>
		this.callApi<IUserStatus[]>(`UserStatus/GetUserStatusList`, "GET");

	getInternalUserDetail = async (
		id: number
	): Promise<InternalUserDetailModel> =>
		this.callApi<InternalUserDetailModel>(`User/GetInternalUser/${id}`, "GET");

	updateInternalUserDetail = async (
		model: InternalUserDetailModel
	): Promise<undefined> =>
		this.callApi<undefined>(`User/UpdateInternalUser`, "PUT", undefined, model);

	saveUserElectronicSignature = async (model: FormData): Promise<number> =>
		this.callApi<number>(
			`UserElectronicSignature/Save`,
			"POST",
			undefined,
			model,
			false,
			true
		);

	updateUserElectronicSignature = async (
		userElectronicSignatureId: number,
		model: FormData
	): Promise<number> =>
		this.callApi<number>(
			`UserElectronicSignature/Update/${userElectronicSignatureId}`,
			"PUT",
			undefined,
			model,
			false,
			true
		);

	getUserMenuAccessRightsList = async (
		userId: number
	): Promise<IMenuAccessRightModel[]> =>
		this.callApi<IMenuAccessRightModel[]>(
			`UserMenuAccessRight/GetUserMenuAccessRightsList`,
			"GET",
			userId > 0
				? new URLSearchParams({
						userId: userId.toString(),
				  })
				: undefined
		);

	saveUpdateUserMenuAccessRight = async (
		model: IAddUpdateUserMenuAccessRight
	): Promise<undefined> =>
		this.callApi<undefined>(
			`UserMenuAccessRight/SaveUpdateAll`,
			"POST",
			undefined,
			model
		);
}

export const InternalUserService = new InternalUserServiceInternal();
